// ©2024 Austin App House. All rights reserved.
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import docImage from '../../assets/doc_image.png';
import CustomSelect from '../layout/CustomSelect';
import { toggleModal } from '../../storage/actions/modalsActions';
import { reloadData } from '../../storage/actions/applicationStateActions';
import Notification from '../notification';
// eslint-disable-next-line import/no-cycle
import { SocketContext } from '../../pages';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../utils/customSelectStyle';
import getTemplatesList from '../../utils/api/get/getTemplatesList';

const ImportWorkOrderModal = ({
  modalState,
  toggleModal: toggleModalAction,
  reloadData: reloadDataAction,
}) => {
  const [file, setFile] = useState(null);
  const [messageImportFile, setMessageImportFile] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const { notificationSocket: socket } = useContext(SocketContext);

  const fetchTemplatesList = async () => {
    const newTemplatesList = await getTemplatesList();
    setTemplates(newTemplatesList);
  };

  useEffect(() => {
    if (socket) {
      socket.on('doneImports', (response) => {
        const { message, type } = response;
        Notification(type, { message });

        if (type === 'success' || type === 'error') {
          toggleModalAction(false, 'loader', true);
          closeModal();
          reloadDataAction();
        }
      });
    }
    fetchTemplatesList();
    return () => {
      setMessageImportFile(null);
    };
  }, []);

  const closeModal = () => {
    setFile(null);
    setSelectedTemplate(null);
    toggleModalAction(false, 'importWorkOrderModal');
  };

  const handlerUploadFile = () => {
    if (!file) {
      setMessageImportFile('Please select file to import.');
      return;
    }
    if (!file.type.includes('csv') && !file.type.includes('excel')) {
      setMessageImportFile('Please select .csv file to import.');
      return;
    }
    setMessageImportFile('');
    toggleModalAction(true, 'loader', true);
    const fd = new FormData();
    fd.append('file', file);
    if (selectedTemplate?.value) fd.append('templateId', selectedTemplate.value);
    axios
      .post('/api/users/import', fd)
      .then((res) => {
        const notificationType = res.data?.success ? 'info' : 'error';
        Notification(notificationType, {
          message: res.data.message,
        });
      })
      .catch((error) => {
        toggleModalAction(false, 'loader', true);
        console.error('Import Work Order Error: ', error);
        setMessageImportFile(error.response?.data?.message || error.message);
      });
  };

  const handlerFile = (event) => {
    if (!event.target.files[0]) {
      setFile(null);
      setMessageImportFile('Please select .csv file to import.');
      return;
    }
    setFile(event.target.files[0]);
    setMessageImportFile('');
  };

  if (!modalState?.isOpen) {
    return null;
  }

  return (
    <div className="modal_block dashboard-modal dashboard-modal--centered modal_import showed">
      <div className="modal_container">
        <div className="modal_head">
          <div className="modal_title">Import Work Order(s)</div>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={closeModal}
          >
            ×
          </button>
        </div>
        <div className="modal_body">
          <div className="info_block">
            <div className="block_sub">Select your CSV file to import</div>
            <a
              href={`${window.location.protocol}//${window.location.hostname}/Sample.xlsx`}
              className="import_link"
              download
            >
              (Please refer to this sample file to create your csv file to import.)
            </a>
          </div>
          <div className="add_btns">
            <label className="standard_btn icon_upload">
              <input type="file" name="file_attach" onChange={handlerFile} />
              Choose file
            </label>
            {messageImportFile && (
              <div className="import_error">{messageImportFile}</div>
            )}
          </div>
          {file && (
            <div className="field_col">
              <div className="import_preview">
                <img src={docImage} alt="" />
                <span>{file.name}</span>
              </div>
            </div>
          )}
          <div className="field_col">
            <label className="field_name" htmlFor="import_template">
              Use Template
            </label>
            <div className="dashboard-select-wrap">
              <CustomSelect
                inputId="import_template"
                isClearable
                isSearchable={false}
                styles={dashboardSelectStyle}
                classNames={dashboardSelectClassNames}
                options={templates}
                value={selectedTemplate}
                onChange={setSelectedTemplate}
                placeholder="Select Template"
              />
            </div>
          </div>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            aria-label="upload"
            onClick={handlerUploadFile}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.importWorkOrderModal,
});

export default connect(mapStateToProps, { toggleModal, reloadData })(ImportWorkOrderModal);
